import gql from 'graphql-tag';

export default gql`
query {
  listUsers {
    items {
      __typename
      id
      emailAddress
      active
      status
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Users/AllQuery.js